import { DumGlobalEventDetailsDto } from '@src/Api/generated-global-event';

export type IItemMaps = {
  coordinates: number[];
  city: string;
  isMythicEvent: boolean;
};

export type IItemTimeLine = {
  title: string;
  description: number;
  isMythicEvent: boolean;
  year: number;
  month: number;
  events: Array<DumDTO>;
};

export type IDataTimeLine = {
  active: IItemTimeLine | undefined;
  starYear?: number;
  endYear?: number;
  list: Array<IItemTimeLine> | [];
};

export type IStatusApi = {
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  message: string;
};

export type IDUMEventListMont = {
  month: number;
  events: Array<DumDTO>;
};

export type IDUMEventListYear = {
  year: number;
  data: Array<IDUMEventListMont>;
};

export const defaultStatusApi = {
  isLoading: true,
  isError: false,
  isSuccess: false,
  message: ''
};

export const defaultDataTimeLine = {
  active: undefined,
  starYear: 2013,
  endYear: 2024,
  list: []
};

export interface DumDTO extends DumGlobalEventDetailsDto {
  isMyhticEvent?: boolean;
  authorImageUrl?: string | null;
  description?: string | null;
  type?: 'dum' | 'casefile';
  globalEventId?: string;
}
export interface IDumSorted {
  title: string;
  description: number;
  year: number;
  month: number;
  isMythicEvent: boolean;
  events: DumDTO[];
}

type StringType = string | undefined | null;
export interface IDumGlobalEventDetailHoverData {
  globalEventId?: string | null;
  country: StringType;
  latlon: [number | undefined, number | undefined];
  investigation: StringType;
  date: string | undefined;
  description: StringType;
  author: StringType;
  authorImageUrl: StringType;
  locationName: StringType;
  reference: StringType;
  scaleOfEvent: number;
  mediaUrl: StringType;
  type?: 'dum' | 'casefile' | 'riftstorm' | 'report';
}
export interface IMapCoordinate extends DumGlobalEventDetailsDto {
  city: string;
  coordinates: number[];
  id: string;
  isMythicEvent: boolean;
  hoverData: IDumGlobalEventDetailHoverData[];
}

export interface IMapCoordinateGrouped {
  locationDetail: string | null;
  coordinate: [number | undefined, number | undefined];
  dumId?: string;
  data: IDumGlobalEventDetailHoverData[];
  onClickItem?: (globalEventId: number) => void;
}

export interface IReqBodyEvent {
  name: string;
  latitude: number;
  longitude: number;
  description: string | undefined;
  reference: string;
  eventDate: string;
  captchaToken?: string | null;
  existingId?: string;
  /**
   * Optional event banner image, sent as the `banner` part of the multipart
   * submission. Undefined means no part is sent at all.
   */
  banner?: File;
  /**
   * Optional external video URL, sent as the `banner_url` text part of the same
   * multipart submission. Independent of `banner` - either, both or neither may
   * be present. Server-side it becomes an `event_media_supports` entry with
   * media_type Video, while `banner` keeps producing the Image entry.
   */
  bannerUrl?: string;
}
